const { qs, qsa, accept, build, alertmessage, prompter } = require('../../libs/qs')
const hexpallettes = require('../../common/hexpallette')
const fxs = require('../common/audiofx')
const { faderH, dualrange } = require("../common/ctrlz.js");
const uuid = require('uuid').v4
const lib = {}


const Sortable = require("sortablejs");
const arrayMove = (array, from, to) => {
    const startIndex = to < 0 ? array.length + to : to
    const item = array.splice(from, 1)[0]
    array.splice(startIndex, 0, item)
}


lib.init = (store, el, audioContext, containers) => {

    // Allow custom container selectors (for multi-rack apps like bytebeatstudio)
    const SEL = containers || {}
    const FXBOX_SEL = SEL.fxbox || '#fxbox'
    const FXLIST_SEL = SEL.fxlist || '#fxlist'
    const FXTITLE_SEL = SEL.fxtitle || '#fxracktitle'
    const getFxBox = () => qs(FXBOX_SEL)
    const getFxList = () => qs(FXLIST_SEL)
    const getFxTitle = () => qs(FXTITLE_SEL)

    return new Promise((resolve, reject) => {
        let sortable

        const compressor = audioContext.createGain()
        const playerGain = audioContext.createGain()

        playerGain.connect(compressor)

        const disconnectRack = () => {
            playerGain.disconnect()
            for (let i = 0; i < store.fxrack.length; i++) {
                try {


                    store.fxrack[i].output.disconnect()
                } catch (e) {
                    //  
                }



            }
        }
        const connectRack = () => {

            if (store.fxrack.length === 0) {
                playerGain.connect(compressor)
                return
            }
            for (let i = 0; i < store.fxrack.length; i++) {

                if (!store.fxrack[i - 1]) {

                    playerGain.connect(store.fxrack[i].input)
                }
                if (store.fxrack[i + 1]) {
                    store.fxrack[i].output.connect(store.fxrack[i + 1].input)
                } else {
                    store.fxrack[i].output.connect(compressor)
                }

            }
            // for(let fx of store.fxrack){
            //    try{


            //    }catch(e){

            //    } 

            // }

        }

        const buildFX = (fx) => {


            const id = uuid()
            const FX = {
                input: audioContext.createGain(),
                output: audioContext.createGain(),
                id: id,
                name: fx.name,
                ison: true
            }

            if (sortable) {
                sortable.destroy()
                sortable = null
            }


            const holdbox = build('li')
            holdbox.classList.add('fxhold')
            holdbox.dataset.id = id
            const inputbox = build('div')


            inputbox.classList.add('fxbox')

            inputbox.classList.add(fx.name)

            inputbox.dataset.id = id

            inputbox.dataset.ison = "true"

            const handle = build('div')
            handle.classList.add('handle')


            handle.innerHTML = fx.name
            const handle2 = build('div')
            handle2.classList.add('topfx')
            const switchid = uuid()
            const onoff = build('input')
            onoff.id = switchid
            onoff.checked = true


            onoff.classList.add('switch')
            onoff.type = 'checkbox'
            const label = build('label')
            label.classList.add('switchlabel')
            label.setAttribute("for", switchid)


            //<input type="checkbox" class="switch" /><label class="switchlabel" for="switch"></label>

            const del = build('button')
            del.classList.add('xbtn')
            del.classList.add('del')
            del.classList.add('icons2')
            del.innerHTML = ''
            const boxhold = build('div')
            boxhold.classList.add('fxcontent')
            handle2.appendChild(del)
            handle2.appendChild(onoff)
            handle2.appendChild(label)
            boxhold.appendChild(handle2)

            inputbox.appendChild(handle)
            inputbox.appendChild(boxhold)

            const ctrlgrid = build('div')
            ctrlgrid.classList.add('ctrlgrid')
            ctrlgrid.classList.add('scroll_enabled2')
            boxhold.appendChild(ctrlgrid)
            let eleminputs = []
            for (let inpt of fx.inputs) {

                switch (inpt.type) {
                    case "knob":
                        const div = build('div')
                        const input = build('input')
                        input.type = "number"
                        input.classList.add('ctrlinput')
                        input.dataset.label = inpt.name
                        input.dataset.uuid = `${inpt.name}-${inputbox.dataset.id}`
                        input.id = `_${inpt.name}-${id}`
                        input.min = inpt.min
                        input.max = inpt.max
                        input.step = inpt.step
                        input.value = inpt.value
                        ctrlgrid.appendChild(div)
                        div.appendChild(input)
                        faderH(input)
                        input.addEventListener('input', () => document.body.dispatchEvent(new CustomEvent('fxvaluechange')))
                        input.addEventListener('change', () => document.body.dispatchEvent(new CustomEvent('fxvaluechange')))
                        eleminputs[inpt.name] = input
                        break
                    case "select":
                        const selbox = build('div')
                        selbox.classList.add('select')
                        const selinput = build('select')
                        for (let opt of inpt.options) {
                            const option = build('option')
                            option.innerHTML = opt.name.toString().replace(/([A-Z])/g, ' $1')
                            option.value = opt.value
                            selinput.appendChild(option)
                        }
                        ctrlgrid.appendChild(selbox)
                        selbox.appendChild(selinput)
                        selinput.addEventListener('change', () => document.body.dispatchEvent(new CustomEvent('fxvaluechange')))
                        eleminputs[inpt.name] = selinput
                        break
                }

            }
            holdbox.appendChild(inputbox)
            getFxBox().appendChild(holdbox)
            sortable = Sortable.create(getFxBox(), {
                handle: ".handle",
                helper: "clone",
                axis: "y",
                onEnd: (/**Event*/evt) => {


                    arrayMove(store.fxrack, evt.oldIndex, evt.newIndex)
                    disconnectRack()
                    connectRack()
                    document.body.dispatchEvent(new CustomEvent('fxstructuralchange'))

                }
            })

            const thisfx = fx.fn(audioContext, eleminputs)
            del.addEventListener('click', (e) => {


                holdbox.remove()
                const index = store.fxrack.findIndex(x => x.id === id)
                store.fxrack.splice(index, 1)
                thisfx.destroy()
                disconnectRack()
                connectRack()

                // Clean up LFO links pointing to this FX's inputs
                const bank = window.openedbank
                const linkBank = window.lfolinks[bank]
                if (linkBank) {
                    for (let linkid in linkBank) {
                        const link = linkBank[linkid]
                        if (link && link.input && link.input.id && link.input.id.includes(id)) {
                            delete linkBank[linkid]
                        }
                    }
                }

                // Notify LFO UI to refresh link lists
                document.dispatchEvent(new CustomEvent('deletefx', { detail: { deleteid: id } }))
                document.body.dispatchEvent(new CustomEvent('fxstructuralchange'))

            })

            FX.input.connect(thisfx.input)
            thisfx.output.connect(FX.output)
            store.fxrack.push(FX)

            disconnectRack()
            connectRack()
            onoff.addEventListener('change', () => {



                FX.ison = !FX.ison
                FX.input.disconnect()
                thisfx.output.disconnect()
                if (FX.ison) {
                    FX.input.connect(thisfx.input)
                    thisfx.output.connect(FX.output)
                } else {
                    FX.input.connect(FX.output)
                }
                document.body.dispatchEvent(new CustomEvent('fxvaluechange'))

            })

            // Save state when FX is created
            document.body.dispatchEvent(new CustomEvent('fxstructuralchange'))

        }


        fxs.fx.forEach((fx, idx) => {

            const option = build('li')
            option.innerHTML = fx.name

            option.addEventListener('click', () => {
                return buildFX(fx)
            })

            getFxList().appendChild(option)
        })


        const fxlistbox = getFxList()
        const fxtitle = getFxTitle()

        document.onclick = function (e) {

            let target = (e && e.target) || (event && event.srcElement);
            let found = false


            if (target == fxlistbox || target == fxtitle) {
                found = true
            } else {
                while (target.parentNode) {

                    if (target == fxlistbox || target == fxtitle) {
                        found = true

                        break;
                    }
                    target = target.parentNode;
                }
            }

            if (!found) {

                getFxList().classList.add('hidden')
            }

        }
        getFxTitle().addEventListener('click', (e) => {
            e.preventDefault()

            getFxList().classList.remove('hidden')
        })

        resolve({
            input: playerGain,
            output: compressor,
            buildFX,
            fxList: fxs.fx,            // expose available FX types for re-population
            getFxBox,
            getFxList,
            getFxTitle
        })
    })

}



module.exports = lib